import Model from './Model';

export default class Note extends Model {
    resource () {
        return 'notes';
    }
}